/**
 * Opens the search modal from header search triggers (pill + mobile icon).
 * Uses capture phase so clicks still work if other handlers interfere.
 *
 * The search snippet may be rendered twice (header + drawer duplicate); guard ensures one listener.
 */

if (!window.__salomonSearchTriggerBound) {
  window.__salomonSearchTriggerBound = true;

  function openSearchModal() {
    const modal = document.getElementById('search-modal');
    if (!modal || typeof modal.showDialog !== 'function') return;
    modal.showDialog();
  }

  /**
   * @param {Event} event
   */
  function handleSearchTriggerClick(event) {
    const target = event.target;
    if (!(target instanceof Element)) return;

    const button = target.closest('.search-action__trigger--mobile, .search-action__header-field');
    if (!button || button.tagName !== 'BUTTON') return;

    const wrapper = button.closest('search-button.search-action');
    if (!wrapper) return;

    event.preventDefault();
    event.stopPropagation();
    openSearchModal();
  }

  document.addEventListener('click', handleSearchTriggerClick, true);
}
